import addLayout from './addLayout';
import form from './form';
import table from './table';

export default {
  layout: 'board-certs-layout',
  addLayout: addLayout,
  table,
  form,
};
